import { RootState } from '../../../../../rootReducer';

export const directorResourcesSelector = (state: RootState) => state.directorModuleReducer.ResourcesReducer;
